// extracted by mini-css-extract-plugin
export default {"title":"DepartmentsTitle_title__ahcfS"};